import { defineMessages } from 'react-intl';

const messages: {
	poweredBy: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	viewInConfluence: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	viewInConfluence: {
		id: 'embedded.confluence.footer.hover.text',
		description:
			'Tooltip text shown on the Confluence footer when the user hovers over it, indicating that clicking will open the page in Confluence.',
		defaultMessage: 'View in Confluence',
	},
	poweredBy: {
		id: 'embedded.confluence.footer.prefix',
		description:
			'Prefix text displayed before the Confluence logo in the embedded Confluence footer, indicating the content is powered by Confluence.',
		defaultMessage: 'Powered by',
	},
});

export default messages;
